module.exports = __webpack_public_path__ + "img/banner2关于我们 手机端.5b8ec2b0.jpg";